import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterRankPipe } from './filter-rank.pipe';



@NgModule({
  declarations: [
    FilterRankPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FilterRankPipe
  ]
})
export class FilterRankModule { }
